/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bi_Dashboard_Authoring_Restrict_Enabled_ToastInputs */



/**
* | output |
* | --- |
* | "Dashboard authoring is now restricted to admins." |
*
* @param {Bi_Dashboard_Authoring_Restrict_Enabled_ToastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bi_dashboard_authoring_restrict_enabled_toast = /** @type {((inputs?: Bi_Dashboard_Authoring_Restrict_Enabled_ToastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bi_Dashboard_Authoring_Restrict_Enabled_ToastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dashboard-Erstellung ist jetzt auf Admins beschränkt.")
	return /** @type {LocalizedString} */ ("Dashboard authoring is now restricted to admins.")
});